import "./iis/iisAction";
import "./script/scriptAction";
import "./healthCheck/healthCheckAction";
import "./tentaclePackage/tentaclePackageAction";
import "./windowsService/windowsServiceAction";
import "./manual/manualAction";
import "./email/emailAction";
import "./azureCloudService/azureCloudServiceAction";
import "./azurePowerShell/azurePowerShellAction";
import "./azureResourceGroup/azureResourceGroupAction";
import "./azureServiceFabricApp/azureServiceFabricAppAction";
import "./azureServiceFabricPowerShell/azureServiceFabricPowerShellAction";
import "./azureWebApp/azureWebAppAction";
import "./certificateImport/certificateImportAction";
import "./dockerNetwork/dockerNetworkAction";
import "./dockerRun/dockerRunAction";
import "./dockerStop/dockerStopAction";
import "./transferPackage/transferPackageAction";
import "./wildfly/deployToWildflyAction";
import "./wildfly/changeStateInWildflyAction";
import "./wildfly/deployToWildflyFeature";
import "./wildfly/deployCertificate";
import "./tomcat/deployToTomcatAction";
import "./tomcat/changeStateInTomcatAction";
import "./tomcat/deployToTomcatFeature";
import "./tomcat/deployCertificate";
import "./javaPackage/javaPackageAction";
import "./javaKeystore/javaKeystoreAction";
import "./vhd/vhdAction";
import "../Features";


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/Actions/index.ts